import { render, staticRenderFns } from "./OverviewSales.vue?vue&type=template&id=33d33475&"
import script from "./OverviewSales.vue?vue&type=script&lang=js&"
export * from "./OverviewSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports